import { CheckoutEvent } from '../../models/checkout/checkout-event.interface';

export const mockCheckoutEvent: CheckoutEvent = {
  eventDescription: 'eventDescription',
  ...new CustomEvent('checkout-event', {
    detail: {
      eventDescription: 'eventDescription',
    },
  }),
};
